import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

import store from '@/store/'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { auth: false }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { auth: true }
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const auth = to.meta.auth || false
  if (auth) {
    const user = store.getters.user

    if (!user) {
      store.dispatch('reAuth').then(result => {
        store.commit('setAuth', result)
        proceed(result.user, auth)
      }).catch(err => {
        console.log('Error reauthenticating. Most likely token expired. ', err)
        store.dispatch('logout')
        next({ name: 'Index' })
      })
    } else {
      proceed(user, auth)
    }
  } else {
    next()
  }

  function proceed (user, auth) {
    const isAllowed = auth && user
    if (isAllowed) next()
    else next({ name: 'Index' })
  }
})

export default router
